import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** Min validity for keycloak updateToken() command */
export const useFlagappKeycloakMinValiditySeconds = (): number => useINTERNALFlag('app-keycloak-min-validity-seconds', {localDefault: 28800});
/** Min validity for keycloak updateToken() command */
export const FlagappKeycloakMinValiditySeconds = (props: PropsNoName) => <INTERNALFlag name="app-keycloak-min-validity-seconds" localDefault={28800} {...props}/>
